"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M21.891 2.12a2.085 2.085 0 0 0-1.488-.619h-5.761c-.378.001-.74.151-1.009.418L2.114 13.437a2.1 2.1 0 0 0 0 2.967l5.485 5.485a2.101 2.101 0 0 0 2.968 0l11.518-11.511c.267-.27.417-.635.416-1.015V3.6a2.073 2.073 0 0 0-.61-1.48ZM18 7.501a1.5 1.5 0 1 1 0-3.002 1.5 1.5 0 0 1 0 3.002Z"
  })]
});